// @ts-ignore
process.turbopack = {};
